// @ts-ignore
process.turbopack = {};
